const BorderedBox = ({ children, className }) => (
	<div
		className={`row mx-0 py-3 px-2 ${className}`}
		style={{
			border: "2px solid #ffffff25",
			borderRadius: 8,
		}}
	>
		{children}
	</div>
);

const BorderedBoxEntry = ({ label, value, colWidth = 6, inline = false }) => (
	<div className={`col-sm-${colWidth}`}>
		<dt className={`text-primary ${inline && "d-inline mr-3"}`}>{label}</dt>
		<dd className={`text-white ${inline && "d-inline"}`}>{value}</dd>
	</div>
);

const Bordered = {
	Box: BorderedBox,
	Entry: BorderedBoxEntry,
};

export { Bordered };
